export const unlockSessionStorageKey = "envship-unlock-session";

export type UnlockSession = {
  email: string;
  unlockedAt: string;
};

export function sanitizeReturnTo(rawReturnTo: string | null | undefined, fallback = "/dashboard") {
  if (!rawReturnTo) return fallback;
  try {
    const decoded = decodeURIComponent(rawReturnTo);
    if (!decoded.startsWith("/") || decoded.startsWith("//")) return fallback;
    if (/^\/(?:login|unlock)(?:$|[/?#])/u.test(decoded)) return fallback;
    return decoded;
  } catch {
    return fallback;
  }
}

export function unlockUrlFor(returnTo: string) {
  return `/unlock?return_to=${encodeURIComponent(sanitizeReturnTo(returnTo))}`;
}

export function loginUrlFor(returnTo: string) {
  return `/login?return_to=${encodeURIComponent(sanitizeReturnTo(returnTo))}`;
}

export function readUnlockSession(storage: Storage): UnlockSession | null {
  try {
    const raw = storage.getItem(unlockSessionStorageKey);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<UnlockSession>;
    if (!parsed.email || !parsed.unlockedAt) return null;
    return { email: parsed.email, unlockedAt: parsed.unlockedAt };
  } catch {
    return null;
  }
}

export function writeUnlockSession(storage: Storage, email: string) {
  storage.setItem(unlockSessionStorageKey, JSON.stringify({ email, unlockedAt: new Date().toISOString() }));
}

export function clearUnlockSession(storage: Storage) {
  storage.removeItem(unlockSessionStorageKey);
}

export function isUnlockComplete(storage: Storage, email: string | null | undefined) {
  if (!email) return false;
  return readUnlockSession(storage)?.email === email;
}
